const doc = [({"en":({"js":({"admin":({"logs":({"headers":({"update":({"update":"Updated"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;